import { Button } from '@/components/ui/button'
import { DropdownPidJPGroup, usePidJP } from '@/components/DropdownPid'
import { MyDatePicker, useDatePicker } from '@/components/MyDatePicker'
import { blobFetcher } from '@/hooks'
import useSWRMutation from 'swr/mutation'
import DataTable from './DataTable'
import { usePackageName, CustomDropdownJP } from '@/components/DropdownPackage'

const JPGroup = () => {
  return (
    <>
      <div className="flex items-center gap-4 flex-wrap sm:gap-2 sm:py-2 xs:py-1 xs:gap-1">
        <DropdownPidJPGroup />
        <CustomDropdownJP />
        <MyDatePicker getMaxDate="complete" showMaxDate={true} />
        <DownloadButton />
      </div>
      <DataTable />
    </>
  )
}
const DownloadButton = () => {
  const startDate = useDatePicker((state) => state.startDate)
  const endDate = useDatePicker((state) => state.endDate)
  const pids = usePidJP((state) => state.pids)

  const country = 'JP'
  const packageName = usePackageName((state) => state.value)

  const { trigger, isMutating } = useSWRMutation(
    ['/reports/roi', { startDate, endDate, pid: pids, country, packageName }],
    blobFetcher,
  )

  const handleDownloadCsv = async () => {
    const { blob, fileName } = await trigger()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName || 'roi_report.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Button onClick={handleDownloadCsv} variant="outline">
      Download csv{isMutating && 'ing...'}
    </Button>
  )
}

export default JPGroup
